import { RootState } from '@core/redux/reducers';

import { SerializedApiError } from 'src/app/typings/global';
import { Roles } from 'src/models/Roles.model';

import { TokenPayload } from './auth.interface';

export const selectIsAuth = (state: RootState): boolean =>
  state.auth.status === 'AUTH';

export const selectHasPermitionMaster = (state: RootState): boolean =>
  state.auth.payload?.roles.includes(Roles.Master) ?? false;

export const selectIsAuthPending = (state: RootState): boolean =>
  state.auth.status === 'PENDING';

export const selectIsRestoringAuth = (state: RootState): boolean =>
  state.auth.status === 'RESTORING';

export const selectHasAuthError = (state: RootState): boolean =>
  state.auth.status === 'ERROR';

export const selectAuthErrorDetails = (
  state: RootState
): SerializedApiError | undefined => state.auth.errorDetails;

export const selectAuthMetadata = (
  state: RootState
): TokenPayload | undefined => state.auth.payload;

export const selectUserEmail = (state: RootState): string | undefined =>
  state.auth.email;
